import { SAVE_NOTIFICATIONS, APPEND_NOTIFICATIONS, UPDATE_NOTIFICATIONS_LIST } from "./constants";

export function saveNotifications(notifications){
    return (dispatch) => {
        dispatch({
            type: SAVE_NOTIFICATIONS,
            data: notifications
          })
    }
}
export function appendNotifications(notifications) {
    return {
      type: APPEND_NOTIFICATIONS,
      payload: notifications,
    };
  }


  export function updateNotificationsList(shouldUpdate) {
    return {
        type: UPDATE_NOTIFICATIONS_LIST,
        payload: shouldUpdate,
    };
}
  
export function reducer(state, action) {
    switch(action.type){
        case SAVE_NOTIFICATIONS:
            return {
                ...state,
                notifications: action.data
            }
        case APPEND_NOTIFICATIONS:
            return {
                ...state,
                notifications: [...state.notifications, ...action.payload],
            };
        case UPDATE_NOTIFICATIONS_LIST: 
            return {
                ...state,
                shouldUpdateNotificationsList: action.payload,
            };
          
        default:
            return state
    }
}

